//export const BASE_URL = 'http://146.190.124.204/';

// getting all base urls from .env file
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_METABUDDY = process.env.REACT_APP_BASE_URL_METABUDDY;

// for apis
export const BASE_URL_API = process.env.REACT_APP_BASE_URL_API;

// for web pages
export const BASE_URL_COMPETITION = process.env.REACT_APP_BASE_URL_COMPETITION;
// for images etc
export const BASE_URL_MEDIA = process.env.REACT_APP_BASE_URL_MEDIA;

// for navigation to trainer portal
export const BASE_URL_TRAINER = process.env.REACT_APP_BASE_URL_TRAINER;

// fot corporate name
export let CORPORATE_NAME = process.env.REACT_APP_CORPORATE_NAME;

export const setCorporateName = (newName) => {
  CORPORATE_NAME = newName;
};

// for corporate logo
export let CORPORATE_LOGO = localStorage.getItem("corporateLogo");

export const setCorporateLogo = (newLogo) => {
  CORPORATE_LOGO = newLogo;
};

export let CORPORTE_DETAIL = ``;
export const setCorporateDetail = (newDetails) => {
  CORPORTE_DETAIL = newDetails;
};

// for components Reistriction
export const IS_CORPORATE =
  process.env.REACT_APP_IS_CORPORATE == "true" ? true : false;
